import { render, staticRenderFns } from "./SasvVerification.vue?vue&type=template&id=3b752cec"
import script from "./SasvVerification.vue?vue&type=script&lang=js"
export * from "./SasvVerification.vue?vue&type=script&lang=js"
import style0 from "./SasvVerification.vue?vue&type=style&index=0&id=3b752cec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports